package com.bikompanion.data.cache

import kotlinx.serialization.Serializable

@Serializable
internal data class CachedStation(
    val id: String,
    val name: String,
    val networkId: String,
    val latitude: Double,
    val longitude: Double,
    val freeBikes: Int,
    val emptySlots: Int,
    val electricBikes: Int,
    val supportsElectricBikes: Boolean = false,
)
